import React from 'react';

const CheckCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    {...props}
  >
    <circle opacity="0.3" cx="11.5" cy="11.5" r="11" stroke="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M16.6938 8.22584C17.0715 8.5528 17.1043 9.11471 16.7671 9.48091L11.0379 15.7031C10.8737 15.8815 10.6422 15.9882 10.3959 15.9991C10.1495 16.01 9.909 15.9241 9.72871 15.7609L6.29121 12.6498C5.92111 12.3149 5.90111 11.7524 6.24654 11.3935C6.59197 11.0346 7.17202 11.0152 7.54213 11.3502L10.2945 13.8412L15.3996 8.29688C15.7367 7.93069 16.3162 7.89888 16.6938 8.22584Z" fill="white"/>
  </svg>
);

export default CheckCircleIcon;
